import React, {FC} from 'react';
import styled from 'styled-components';

import {Loader} from '../../../../../libs/shared/ui/src/components/loaders/loader';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Style.
 */

const StyledLoaderWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

/*
 * Component.
 */

export const ButtonLoader: FC = () => (
  <StyledLoaderWrapper>
    <Loader size={VisualSizesEnum.SMALL} isEnabled />
  </StyledLoaderWrapper>
);
